module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.attribute.label,
      "withBody": false,
      "withFooter": false,
      "to": {
        name: 'attribute',
        params: {
          attributeId: _vm.attribute._id.$oid,
          identifier: _vm.identifier
        }
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('drop', [_c('button', {
    staticClass: "btn",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('i', {
    staticClass: "dropbtn fa fa-ellipsis-v"
  })]), _vm._v(" "), _c('drop-content', {
    attrs: {
      "slot": "content",
      "placement": "bottom-end"
    },
    slot: "content"
  }, [_c('ul', {
    staticClass: "c-nav c-nav--menus"
  }, [_c('li', {
    staticClass: "c-nav__item"
  }, [_c('a', {
    staticClass: "c-nav__link",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showModal()
      }
    }
  }, [_vm._v("Excluir")])]), _vm._v(" "), _vm._t("default")], 2)])], 1)], 1), _vm._v(" "), _c('modal-delete', {
    attrs: {
      "attribute": _vm.attribute
    },
    on: {
      "option": _vm.remove
    },
    model: {
      value: (_vm.modalFlag),
      callback: function($$v) {
        _vm.modalFlag = $$v
      },
      expression: "modalFlag"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad080120","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MarketplaceAttribute/AttributeCard.vue
// module id = 3397
// module chunks = 0